import { Id } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, projectId: Id) {
  return getState().find((res) => res.projectId === projectId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isProjectLogsRetrievalRequestFailure(projectId) {
      return queryState(getState, projectId)(
        (res) => res.request.isFailure,
        false,
      );
    },
    isProjectLogsRetrievalRequestPending(projectId) {
      return queryState(getState, projectId)(
        (res) => res.request.isPending,
        false,
      );
    },
    isProjectLogsRetrievalRequestSuccess(projectId) {
      return queryState(getState, projectId)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
    getProjectLogs(projectId) {
      return queryState(getState, projectId)((res) => res.logs, []);
    },
  };
}

export { createSelector };
